<template>
    <div>
        <div class="card shadow">
            <div class="card-header bg-transparent">
                <div>
                    <h2 class="mb-0">
                        {{ $tc('message.kinesitherapyConsultations', 1) }}
                    </h2>
                </div>
            </div>

            <div class="card-body">
                <b-tabs
                        card
                        content-class="mt-3"
                        fill
                        active-nav-item-class="font-weight-bold text-uppercase text-success"

                >
                    <b-tab no-body :title="$t('message.infoConsultation')"
                    >
                        <b-row>
                            <b-col  col sm="8">
                                <div class="list-group">
                                    <b-row>
                                        <b-col col sm="12" class="mb-3">
                                            <div class="">
                                                <h4 class="consultation-item__title"> {{ $t('message.institutionConsultation') }} </h4>
                                                <span class="font-weight-bold">
                                                    <p class="consultation-item__body"> {{ etablissement }} </p>
                                                </span>
                                            </div>
                                        </b-col>

                                        <b-col col sm="12" class="mb-3">
                                            <div class="">
                                                <h4 class="consultation-item__title"> {{ $tc('message.practitioners',1) }} </h4>
                                                <span class="font-weight-bold">
                                                    <p class="consultation-item__body"> {{ praticien }} </p>
                                                </span>
                                            </div>
                                        </b-col>

                                        <b-col col sm="12" class="mb-3">
                                            <div class="">
                                                <h4 class="consultation-item__title">{{ $t('message.consultationDate') }} </h4>


                                                <p class="consultation-item__body"> {{ formattedDate(mConsultation.date_consultation) }} </p>

                                            </div>
                                        </b-col>

                                        <b-col col sm="12" class="mb-3" v-if="contributeurs.length>0">
                                            <div class="">
                                                <h4 class="consultation-item__title"> {{ $tc('message.contributors',2) }} </h4>
                                                <span class="font-weight-bold" v-for="contributeur in contributeurs" :key="contributeur.nom">
                                                    <p class="consultation-item__body"> {{ contributeur.nom }} </p>
                                                </span>
                                            </div>
                                        </b-col>

                                        <b-col col sm="12" class="mb-3">
                                            <div class="">
                                                <h4 class="consultation-item__title"> {{ $tc('message.reasons', 1) }} </h4>
                                                <p class="consultation-item__body">{{ reasons }}</p>
                                            </div>
                                        </b-col>
                                    </b-row>

                                    <b-row>
                                        <b-col col sm="12" class="mb-3">
                                            <div class="">
                                                <h4 class="consultation-item__title"> {{ $t('message.anamnesis') }} </h4>

                                                <p class="consultation-item__body" v-html="mConsultation.anamnese">  </p>

                                            </div>
                                        </b-col>
                                    </b-row>

                                    <b-row>
                                        <b-col col sm="12" class="mb-3">
                                            <div class="">
                                                <h4 class="consultation-item__title"> {{ $t('message.evaluationGlobale') }} </h4>

                                                <p class="consultation-item__body" v-html="mConsultation.evaluation_globale">  </p>

                                            </div>
                                        </b-col>
                                    </b-row>    

                                    <b-row>
                                        <b-col col sm="12" class="mb-3">
                                            <div class="">
                                                <h4 class="consultation-item__title"> {{ $t('message.examensComplementaires') }} </h4>

                                                <p class="consultation-item__body" v-html="mConsultation.examens_complementaires">  </p>

                                            </div>
                                        </b-col>
                                    </b-row>     

                                    <b-row>
                                        <b-col col sm="12" class="mb-3">
                                            <div class="">
                                                <h4 class="consultation-item__title"> {{ $t('message.impressionDiagnostique') }} </h4>

                                                <p class="consultation-item__body" v-html="mConsultation.impression_diagnostique">  </p>

                                            </div>
                                        </b-col>
                                    </b-row> 
                                    <!--                                    //Allergies-->
                                    <!--                        Conduite à tenir-->
                                    <b-row>
                                        <b-col col sm="12">
                                            <div class="">
                                                <h4 class="consultation-item__title"> {{ $t('message.suggestTreatment') }} </h4>
                                                <p class="consultation-item__body" v-html="mConsultation.conduite_a_tenir"> </p>
                                            </div>
                                        </b-col>
                                    </b-row>
                                    <!--                                    Rendez vous-->
                                    <b-row>
<!--                                        <b-col col sm="12" class="mb-3">-->
<!--                                            <div class="">-->
<!--                                                <h4>{{ $tc('message.appointments',1) }} </h4>-->

<!--                                                <p> {{ formattedDate(mConsultation.rendez_vous) }} </p>-->

<!--                                            </div>-->
<!--                                        </b-col>-->
                                        <b-col col sm="12" v-if="mConsultation.rdv">
                                            <div class="">
                                                <h4 class="consultation-item__title">{{ $t('message.appointmentDate') }} </h4>

                                                <p class="consultation-item__body" v-html="mConsultation.rdv.date"></p>

                                            </div>
                                        </b-col>
                                        <b-col col sm="12" v-if="mConsultation.rdv">
                                            <div class="">
                                                <h4 class="consultation-item__title">{{ $t('message.appointmentReason') }} </h4>

                                                <p class="consultation-item__body" v-html="mConsultation.rdv.motifs"></p>

                                            </div>
                                        </b-col>
                                    </b-row>
                                </div>

                            </b-col>
                            <b-col col sm="4">
                                <b-row class="justify-content-sm-center">

                                    <div class="card-footer text-right">
                                        <div v-if="!hasGestionnaireRole" @click="ImprimerConsultation" class="custom-print-wrapper">
                                            <button class="custom-print-button">
                                                <span class="custom-print-icon"></span>
                                            </button>
                                            <p class="custom-print-label">
                                                {{ $t('message.print') }}  {{ $tc('message.consultations', 1) }}
                                            </p>
                                        </div>
                                        <br>
                                        <br>
                                        <b-button variant="primary" @click="updateConsultation" v-if="canUpdate">
                                            {{ $t('message.edit') }}
                                        </b-button>
                                        <br>
                                        <br>

                                        <b-button variant="success" @click="archieveConsultation" v-if="isTransmitted && !isArchived && (hasMedecinControleRole || hasAdminRole || hasAssistante)" >
                                            {{ $t('message.archieve') }}
                                        </b-button>
                                        <br>
                                        <b-button variant="info" @click="transmitConsultation" v-if="!isTransmitted && !isArchived && mConsultation.canUpdate && (hasPraticienRole || hasAdminRole || hasMedecinControleRole || hasAssistante)">
                                            {{ $t('message.transmit') }}
                                        </b-button>
                                        <br>
                                        <br>

                                        <b-button variant="info" @click="reactiveConsultation" v-if="canReactive">
                                            {{ $t('message.reavivate') }} {{$tc('message.consultations',1) }}
                                        </b-button>
                                        <br>
                                        <br>

                                        <b-button v-b-modal.delete-modal variant="danger" v-if="canDelete">
                                            {{ $t('message.delete') }}
                                        </b-button>
                                        <br>
                                        <p v-if="errorshasField('nonTransmis')" style="color:red"  class="justify-content-sm-center">
                                            {{getErrorsField('nonTransmis')}}
                                        </p>
                                    </div>
                                </b-row>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col col sm="12">
                                <div v-if="files.length>0">
                                    <h4>Fichier joint </h4>
                                    <div  v-for="file in files" :key="file.id">
                                        <b-row>
                                            <b-col col sm="6">
                                                <p class="mb-3"> {{file.nom}}</p>
                                            </b-col>
                                            <b-col col sm="6">
                                                <button type="button" class=" ml-5 btn btn-success btn-sm" @click="openFile(file)">Afficher</button>
                                            </b-col>
                                        </b-row>
                                    </div>
                                </div>
                            </b-col>
                        </b-row>
                    </b-tab>

                </b-tabs>
                <div class="card">
                    <b-modal
                            id="delete-modal"
                            size="sm"
                            header-bg-variant="danger"
                            header-text-variant="light"
                            :title="$t('message.delete') + ' ' + $tc('message.kinesitherapyConsultations', 1)"
                            hide-footer
                    >
                        <div class="d-block text-center">
                            <h3>{{ $t('message.delete') }} cardio {{ formattedDate(mConsultation.date_consultation) }}</h3>
                        </div>

                        <div class="d-block float-right">
                            <b-button variant="danger" @click="deleteConsultation" >
                                {{ $t('message.delete') }}
                            </b-button>

                            <b-button variant="secondary" @click="$bvModal.hide('delete-modal')">
                                {{ $t('message.cancel') }}
                            </b-button>
                        </div>
                    </b-modal>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import _ from "lodash";
    import AppConfig from "../../../constants/AppConfig";
    import moment from "moment";
    import $ from "jquery";

    export default {
        name: "Kinesitherapy",

        computed: {
            ...mapGetters(["KinesitherapieConsultation",
                'errors',
                'hasAdminRole',
                'hasMedecinControleRole','hasAssistante',
                "hasSouscripteurRole",
                "hasPatientRole",
                'hasPraticienRole',
                'hasGestionnaireRole']),

            image: function() {
                if (!_.isUndefined(this.mConsultation.file) && !_.isNull(this.mConsultation.file)){
                    if (this.mConsultation.file.length >0 && this.mConsultation.file != 'null'){
                        return AppConfig.imgUrl + '/public/storage/' + this.mConsultation.file;
                    }
                    return "";
                }
                return "";
            },

            mConsultation: function() {
                return this.KinesitherapieConsultation;
            },

            isTransmitted: function() {
                return !_.isNull(this.KinesitherapieConsultation.passed_at );
            },

            isArchived:function(){
                return   !_.isNull(this.KinesitherapieConsultation.archieved_at );
            },

            praticien:function(){
               
              if(this.mConsultation.hasOwnProperty("author"))
              {
                let author = this.mConsultation.author;
                if (!_.isUndefined(author) && !_.isNull(author)) {
                    let prenom = (author.prenom == null) ? '' : author.prenom;
                        return (author.nom).toUpperCase() + " " +prenom.charAt(0).toUpperCase() + prenom.substring(1);
                     }
            }else{
                return  "";
            }
                                        
            },

            examens:function(){
                let eArray = [];
                _.forEach(this.mConsultation.examen_cardios,function (examen) {
                    eArray.push({nom:examen.nom,description:examen.description,date:examen.date_examen,slug:examen.slug,id:examen.id});
                });
                return eArray;
            },

            contributeurs:function(){
                let cArray = [];
                if (!_.isUndefined(this.mConsultation.operationables)){
                    _.forEach(this.mConsultation.operationables,function (operation) {
                        if (!_.isUndefined(operation.contributable)){
                            let contributable = operation.contributable;
                            let prenom = contributable.prenom != 'null' ? contributable.prenom : '';
                            prenom =  prenom.toLowerCase();
                            let nomComplet = (contributable.nom).toUpperCase() + " "+ prenom.charAt(0).toUpperCase() + prenom.substring(1);
                            cArray.push({nom:nomComplet})  ;
                        }
                    });
                }
                return cArray;
            },

            files:function(){
                return _.isUndefined(this.mConsultation.files) ? [] :this.mConsultation.files;
            },

            isAuthor:function(){
                return this.mConsultation.isAuthor;
            },

            canUpdate:function(){
                return this.mConsultation.canUpdate;
            },

            canReactive:function(){
                return !_.isNull(this.mConsultation.passed_at) && (this.hasAdminRole || this.hasMedecinControleRole || this.hasAssistante);
            },

            canDelete:function(){
                if (this.hasAdminRole)
                    return true;

                return this.mConsultation.canUpdate && _.isNull(this.mConsultation.archieved_at) && _.isNull(this.mConsultation.passed_at);
            },

            etablissement:function(){
                if (!_.isUndefined(this.mConsultation.etablissement)){
                    if (!_.isNull(this.mConsultation.etablissement)){
                        return this.mConsultation.etablissement.name;
                    }
                    return "";
                }
                return  "";
            },

            nom: function() {
                if (typeof(this.mConsultation.dossier) =='object'){
                    let user = this.mConsultation.dossier.patient.user;

                    let nom = user.nom;
                    let prenom = user.prenom != null ? user.prenom : '';

                    return  prenom +" "+ nom.toUpperCase();
                }else{
                    return "";
                }
            },

            reasons:function(){
                let motifs ="";
                if(!_.isUndefined(this.mConsultation.motifs)){
                    let self = this;
                    _.forEach(this.mConsultation.motifs,function (motif,key) {
                        motifs = motifs + ((key != self.mConsultation.motifs.length && key != 0) ? "," : " ") + motif.description;
                    });

                    return motifs +" .";
                }
                return motifs + " .";
            },

            reasonsRows:function(){
                let mArray = [];
                if(!_.isUndefined(this.mConsultation.motifs)) {
                    _.forEach(this.mConsultation.motifs, function (motif) {
                        mArray.push({reference:motif.reference,description: motif.description,slug:motif.slug})
                    });
                }
                return mArray;
            },

        },

        data() {
            return {
                afficher : 0,

                consultation_id: this.$route.params.kinesitherapie,

                traitementsColumns:[
                    {
                        label: 'Description',
                        field: 'description',
                        html: true,
                    },
                ],

                reasonsColumns:[
                    {
                        label: this.$i18n.t('message.reference'),
                        field: 'reference',
                    },
                    {
                        label: this.$i18n.t('message.description'),
                        field: 'description',
                        html: true,
                    },
                ],

                conclusionsColumns:[
                    {
                        label: this.$i18n.t('message.reference'),
                        field: 'reference',
                    },
                    {
                        label: this.$i18n.t('message.description'),
                        field: 'description',
                        html: true,
                    },
                ],


                paginationOptions:{
                    enabled: true,
                    mode: 'records',
                    perPageDropdown: [3, 6, 10]
                },

                enabled:{enabled: true},

                sort:{
                    enabled: true,
                    initialSortBy: {field: 'date', type: 'desc'}
                },

            }
        },

        methods: {
            onCardioExamRowClick(params){
                this.$router.push({name: 'kinesitherapy-exam', params: {kinesitherapy: params.row.slug}});
            },

            toCardioExam(){
                this.$router.push({name: 'add-kinesitherapy-exam', params: {kinesitherapy: this.consultation_id}});

            },

            openFile(file){
                window.open(AppConfig.imgUrl + '/public/storage/' + file.chemin);
            },

            ImprimerConsultation(){
                let args = {
                    kinesitherapie: this.consultation_id
                };

                this.$store.dispatch("printConsultationKinesitherapie", { args });
            },

            reasonsRowClick(params){
                this.$router.push({ name: 'reason', params: { reason: params.row.slug } });

            },

            allerA(item){
                return this.$route.path + item;
            },

            notEmpty(item){
                return item.length > 0;
            },


            toAddCommonParameter(){
                this.$router.push({name: 'add-parameter-common',params:{ consultation: this.consultation_id}})
            },

            toConclusion(){
                this.$router.push( { name: 'conclusions', params: { consultation: this.consultation_id } })
            },

            getConsultation() {
                let args = {
                    consultation: this.consultation_id
                };

                this.$store.dispatch("getKinesitherapieConsultation", { args });
            },

            formattedDate(date) {
                return !_.isNull(date) ? moment(date).format('DD-MM-YYYY') : "";
            },

            updateConsultation() {
                this.$router.push({ name: 'edit-consultation-kinesitherapy', params: { consultation: this.consultation_id } });
            },

            deleteConsultation() {
                let self = this;
                let args = {
                    consultation: this.consultation_id
                };

                let successMessage = this.$i18n.t('message.kinesitherapyConsultationsDeleted');
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.error')
                };

                this.$store.dispatch('deleteKinesitherapieConsultation', { args, successMessage, errorMessages }).then(() => {
                    self.$bvModal.hide('delete-modal');
                    this.$router.back();

                });
            },

            archieveConsultation(){
                let self = this;
                let args = {
                    consultation: this.consultation_id
                };

                let successMessage = this.$i18n.t('message.kinesitherapyConsultationArchieved');
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.error')
                };

                this.$store.dispatch('archieveKinesitherapieConsultation', { args, successMessage, errorMessages });

            },

            transmitConsultation(){
                let self = this;
                let args = {
                    consultation: this.consultation_id
                };

                let successMessage = this.$i18n.t('message.kinesitherapyConsultationTransmitted');
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.error')
                };

                this.$store.dispatch('transmitKinesitherapieConsultation', { args, index: self.consultation_id, successMessage, errorMessages });

            },

            reactiveConsultation(){
                let self = this;
                let args = {
                    consultation: this.consultation_id
                };

                let successMessage = this.$i18n.t('message.kinesitherapyConsultationReactived');
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.error')
                };

                this.$store.dispatch('reactiveKinesitherapieConsultation', { args, index: self.consultation_id, successMessage, errorMessages });

            },

            /*isArchived:function(date){
                let momentDate = moment(date);
                return !momentDate.isValid() ;
            },*/

          /*  isTransmitted:function(date){
                var momentDate = moment(date);
                return !momentDate.isValid() ;
            },*/

            getErrorsField(field){
                if (this.errorshasField(field)){
                    return this.errors[field][0];
                }else{
                    return  '';
                }
            },
            errorshasField(field){
                return this.errors ? this.errors.hasOwnProperty(field) : false;
            },
            clearErrorField(field){
                this.$store.dispatch('clearErrorField', { field });
                this.getErrorsField(field);
            },
            pathHas(element){
                let result = (this.$route.fullPath).includes(element);
                if(result){
                    if ($('#'+element).length){
                        document.getElementById(element).scrollIntoView(top);
                    }
                }

                return result;
            }
        },

        mounted() {
            this.getConsultation();
        }
    }
</script>

<style scoped>

</style>